export default function getTimeZone(): number {
    return new Date().getTimezoneOffset();
}